import {API_BASE_URL} from "./constants";

export const getApiUrl = (path: string) => {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${API_BASE_URL.replace(/\/$/, '')}${normalizedPath}`;
}
